import { useMemo } from 'react';
import { usePerformanceQuery } from '../api/usePerformanceQuery';
import { usePeriod } from './usePeriod';
import { useRouteParams } from './useRouteParams';
import { SERIES_COLORS } from '../../CommonComponents/OPL/charts/charts.constants';

export const usePerformanceVsBenchmark = () => {
  const period = usePeriod();

  const { accountId, clientId, groupId } = useRouteParams();

  const queryInfo = usePerformanceQuery({
    clientId,
    period: period.value,
    startDate: period.dates[0],
    endDate: period.dates[1],
    accountId,
    groupId,
  });

  const chartTitle =
    queryInfo.data &&
    Array.isArray(queryInfo.data.performanceVsBenchmark) &&
    queryInfo.data.performanceVsBenchmark.length > 1
      ? 'Performance vs Benchmark'
      : 'Performance';

  const data = useMemo(() => {
    if (!queryInfo.data) {
      return null;
    }

    const { performanceVsBenchmark } = queryInfo.data;

    return performanceVsBenchmark.map(
      ({ name, data: performanceVsBenchmarkData, color }, index) => ({
        name,
        data: performanceVsBenchmarkData.map(({ date, value }) => {
          const parsedDate = new Date(date);
          const timeStampDate = parsedDate.getTime();
          return [timeStampDate, value - 1];
        }),
        color: color || SERIES_COLORS[index % SERIES_COLORS.length],
      }),
    );
  }, [queryInfo.data]);

  return { ...queryInfo, data, chartTitle };
};
